import { useState, useEffect } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";

const SettlementReportValueModal = ({
  show,
  handleClose,
  currentValues,
  currentScreenBy,
  onSave,
}) => {
  const [screenBy, setScreenBy] = useState({
    settlement: false,
    settled: false,
    settlement_check_received: false,
    balance_remaining_in_trust: false,
  });

  useEffect(() => {
    if (currentScreenBy) {
      setScreenBy(currentScreenBy);
    }
  }, [currentValues, currentScreenBy, show]);

  const handleApply = () => {
    onSave({
      screenBy: screenBy,
    });
  };

  const selectedCount = Object.values(screenBy).filter(Boolean).length;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <div style={{ minHeight: "max-content" }}>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Settlement Report Values ({selectedCount} selected)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5" style={{ minHeight: "max-content" }}>
          <div className="custom-tab">
            {/* Screen By Section */}
            <Row className="mx-0 pe-0 m-b-10">
              <Col md={12} className="p-0">
                <div
                  className="m-b-5"
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "var(--primary)",
                  }}
                >
                  Screen By:
                </div>

                {/* Checkboxes - 2 columns */}
                <div className="d-flex flex-wrap mx-0 align-items-center m-b-5">
                  <div className="col-md-6 p-l-0 p-r-5">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.settlement}
                        onChange={(e) => setScreenBy({ ...screenBy, settlement: e.target.checked })}
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          minHeight: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Settlement
                    </label>
                  </div>

                  <div className="col-md-6 p-l-0 pe-0">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.settled}
                        onChange={(e) => setScreenBy({ ...screenBy, settled: e.target.checked })}
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Settled
                    </label>
                  </div>
                </div>

                <div className="row mx-0 align-items-center">
                  <div className="col-md-6 p-l-0 p-r-5">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.settlement_check_received}
                        onChange={(e) =>
                          setScreenBy({ ...screenBy, settlement_check_received: e.target.checked })
                        }
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Settled Check Received
                    </label>
                  </div>

                  <div className="col-md-6 p-l-0 pe-0">
                    <label
                      className="d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={screenBy.balance_remaining_in_trust}
                        onChange={(e) =>
                          setScreenBy({ ...screenBy, balance_remaining_in_trust: e.target.checked })
                        }
                        style={{
                          marginRight: "5px",
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      Balance Remaining in Trust Account
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            onClick={handleApply}
          >
            Apply Selection
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default SettlementReportValueModal;
